import React from 'react';
import {Route, Switch} from "react-router-dom";

import TakenAwardList from "./TakenAwardList";

class TakenAwards extends React.Component {
  render() {
    return (
      /* page content */
      <div id="takenAward-page" className="right-col" role="main">
        <div className="page-title">
          <h3>Vyzvednuté odměny</h3>
        </div>
        <Switch>
          <Route exact path="/takenAwards" component={(props) => <TakenAwardList {...this.props} />} />
        </Switch>
      </div>
    );
  }
}

export default TakenAwards;




/** WEBPACK FOOTER **
 ** ./src/containers/TakenAwards/index.js
 **/